import React from "react";
import { TERMS_CONTACT_EMAIL } from "../../core/constants";
import { useI18n } from "../../features/i18n/LocaleProvider";
import PolicyPage from "./PolicyPage";

export default function TermsPage({ acc }) {
  const { t } = useI18n();
  const sections = [
    { heading: t("terms_h1"), body: t("terms_b1") },
    { heading: t("terms_h2"), body: t("terms_b2") },
    { heading: t("terms_h3"), body: t("terms_b3") },
    { heading: t("terms_h4"), body: t("terms_b4") },
    { heading: t("terms_h5"), body: t("terms_b5") },
    { heading: t("terms_h6"), body: t("terms_b6") },
    { heading: t("terms_h7"), body: `${t("terms_b7")}: ${TERMS_CONTACT_EMAIL}` },
  ];

  return <PolicyPage title={t("terms_of_service")} updatedAt={t("policy_updated_at")} sections={sections} acc={acc} />;
}
